import React from 'react'
import './DescriptionBox.css'
const DescriptionBox = () => {
    return (
        <div className='descriptionbox'>
            <div className='descriptionbox-navigator'>
                <div className='descriptionbox-nav-box'>
                    Description
                </div>
                <div className='descriptionbox-nav-box fade'>
                    Reviews (122)
                </div>
            </div>
            <div className='descriptionbox-description'>
                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Incidunt laborum maiores sapiente quos quae eveniet sed nesciunt tempora eum laboriosam voluptatem aspernatur blanditiis, fugiat saepe, quia provident, error hic nemo nam ducimus possimus dolorum. Fuga alias vitae neque id iste.</p>
                <p>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Facere voluptates modi tempora veniam recusandae eum quae, beatae officia rerum, explicabo magni? Veniam porro fugit aspernatur assumenda qui animi reiciendis explicabo.                </p>
            </div>
        </div>
    )
}

export default DescriptionBox